/**
 * Get front face index
 * ---------------------
 * @param {Array<{face_angle: string}>} log
 * @returns {number}
 */
export const getFrontFaceIndex = (arr) => {
  if (!Array.isArray(arr)) {
    console.error("Expected array");
    return -1;
  }

  const idx = arr.findIndex((item) => {
    return item.face_angle === "front";
  });

  if (idx === -1) {
    console.error("Front face not found for this person");
  }

  return idx;
};

export const getFrontFaceWithFallback = (arr) => {
  if (!Array.isArray(arr)) {
    console.error("Expected array");
    return -1;
  }

  if (arr.length === 0) {
    console.error("No face available");
    return -1;
  }

  const idx = arr.findIndex((item) => {
    return item.face_angle === "front";
  });

  if (idx === -1) {
    console.error("Front face not found for this person");
    return 0;
  }

  return idx === -1 ? 0 : idx;
};
